import resume from "../assets/pdf/Rahul_Singh_Resume.pdf";


export const headerData = {
  
  name: "Rahul Singh",
  title: "Full Stack Web Developer",
  desciption:
    "I'm a full stack web developer based in India. I am highly-proficient in MERN stack and looking for opportunities to learn and build. So...let's connect! and start building!",
  image: "https://ca.slack-edge.com/T02QFJUB5DF-U03AS34NCG3-7f56b8652531-512",
  resumePdf: resume,
};
